import { skipToken } from "@reduxjs/toolkit/query";
import { useGetOrgByIdQuery } from "../../state/rtk-query/state/organization";

export function useIsNewAdmire(orgId?: number) {
  const { currentData } = useGetOrgByIdQuery(orgId ? { orgId } : skipToken, {
    skip: !orgId,
  });
  return currentData?.license_status?.license?.name === "The New Admire";
}
